/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerability {
    getFixupPrototypeFunction() { return AppSecopsVulnerability.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerability>): AppSecopsVulnerability {
        let obj = Object.assign(new AppSecopsVulnerability(), model);
        AppSecopsVulnerability.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerability>): AppSecopsVulnerability {
        if (!model) return null;
        return AppSecopsVulnerability.newInstance(<AppSecopsVulnerability> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerability) {
        if (!obj) return;

        models.AppSecopsVulnerability.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerability): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerability.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.vulnerability_id) {
            models.AppSecopsVulnerabilityCveDetail.fixupPrototype(this.vulnerability_id);
        }
        if (this.epss_metric) {
            models.AppSecopsVulnerabilityEpssScore.fixupPrototype(this.epss_metric);
        }
        if (this.cvss_metrics) {
            for (let val of this.cvss_metrics) {
                models.AppSecopsVulnerabilityCvssMetric.fixupPrototype(val);
            }
        }
        if (this.fix_available) {
            for (let val of this.fix_available) {
                models.AppSecopsVulnerabilityFixAvailableDetails.fixupPrototype(val);
            }
        }
        if (this.details_from_source) {
            for (let val of this.details_from_source) {
                models.AppSecopsVulnerabilitySourceDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID of the vulnerability
     */
    id: string;

    vulnerability_id: models.AppSecopsVulnerabilityCveDetail;

    /**
     * Indicates whether the vulnerability is a Known Exploited Vulnerability
     */
    is_kev: boolean;

    /**
     * EPSS metrics associated with the vulnerability
     */
    epss_metric: models.AppSecopsVulnerabilityEpssScore;

    /**
     * CVSS metrics associated with the vulnerability captured from different source.
     */
    cvss_metrics: Array<models.AppSecopsVulnerabilityCvssMetric>;

    fix_available: Array<models.AppSecopsVulnerabilityFixAvailableDetails>;

    aliases: Array<string>;

    details_from_source: Array<models.AppSecopsVulnerabilitySourceDetails>;

}
